import { render, staticRenderFns } from "./examenes.vue?vue&type=template&id=79386104&scoped=true"
import script from "./examenes.vue?vue&type=script&lang=js"
export * from "./examenes.vue?vue&type=script&lang=js"
import style0 from "./examenes.vue?vue&type=style&index=0&id=79386104&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79386104",
  null
  
)

export default component.exports